import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';

import CareCoordinatorForm from '../../../../components/Manage/CareCoordinatorForm';

import IconPlus from 'cccisd-icons/plus-circle2';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const AddCareCoordinatorForm = props => {
    const modal = useRef();

    const onSubmit = async values => {
        const hasSupervisor = !!values.supervisor;

        const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
            role: 'careCoordinator',
            username: values.username,
            email: values.username,
            first_name: values.firstName,
            last_name: values.lastName,
            group: values.site,
            parentPawns: hasSupervisor ? JSON.stringify([values.supervisor]) : JSON.stringify([]),
            managePageAccess: values.managePageAccess,
            dashboardPageAccess: values.dashboardPageAccess,
            administerPageAccess: values.administerPageAccess,
            receiveAlertsImmediately: hasSupervisor ? values.receiveAlertsImmediately : false,
            receiveAlertsDigest: hasSupervisor ? values.receiveAlertsDigest : false,
            receiveNotifications: hasSupervisor ? values.receiveNotifications : false,
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ message: errorMessage, type: 'danger' });
            return Promise.reject(response.data.errors);
        }

        await props.loadData();
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <span>
                        <IconPlus spaceRight />
                        Add Care Coordinator
                    </span>
                </button>
            }
            title="Add New Care Coordinator"
            size="large"
        >
            <CareCoordinatorForm
                onSubmit={onSubmit}
                initialValues={{
                    username: '',
                    firstName: '',
                    lastName: '',
                    site: [],
                    supervisor: '',
                    managePageAccess: true,
                    dashboardPageAccess: true,
                    administerPageAccess: true,
                    receiveAlertsImmediately: false,
                    receiveAlertsDigest: true,
                    receiveNotifications: true,
                }}
            />
        </Modal>
    );
};

export default AddCareCoordinatorForm;
